import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../App'; // Importe le hook d'authentification
// Ajout de l'icône CheckCircle
import { Wallet, UserPlus, AlertCircle, Mail, Lock, CheckCircle } from 'lucide-react'; 

function RegisterPage() {
  const { register } = useAuth();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  // --- 1. NOUVEL ÉTAT POUR L'AFFICHAGE DU SUCCÈS ---
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }
    
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      // Appelle la fonction d'inscription (qui n'essaie plus de se connecter)
      await register(email, password);

      // --- 2. MODIFICATION DE LA LOGIQUE DE SUCCÈS ---
      // Au lieu de rediriger, on affiche le message de succès
      setLoading(false);
      setSuccess(true);
      // --- FIN MODIFICATION ---

    } catch (err) {
      // Gère les erreurs (ex: email déjà utilisé)
      if (err.response && err.response.data && err.response.data.detail) {
        if (err.response.data.detail.includes("Email already registered")) {
            setError('Cet e-mail est déjà utilisé.');
        } else {
            // Affiche l'erreur de SendGrid si elle se produit
            setError(err.response.data.detail || 'Une erreur est survenue lors de l\'inscription.');
        }
      } else {
         setError('Une erreur est survenue lors de l\'inscription.');
      }
      setLoading(false); // Stoppe le chargement uniquement en cas d'erreur
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-success-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo et Titre */}
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="bg-gradient-to-r from-primary-600 to-success-600 text-white rounded-2xl p-4 shadow-xl">
              <Wallet className="h-12 w-12" />
            </div>
          </div>
          <h1 className="text-4xl font-bold mb-2 bg-gradient-to-r from-primary-600 to-success-600 bg-clip-text text-transparent">
            Budget Tracker
          </h1>
          <p className="text-gray-600">
            Créez votre compte pour commencer
          </p>
        </div>

        {/* Formulaire */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-100">
          
          {/* --- 3. AFFICHAGE CONDITIONNEL --- */}
          {success ? (
            // --- Message de Succès ---
            <div className="text-center">
              <div className="flex justify-center">
                <div className="bg-green-100 rounded-full p-3">
                  <CheckCircle className="h-8 w-8 text-green-600" />
                </div>
              </div>
              <h2 className="mt-4 text-xl font-semibold text-gray-900">
                Inscription réussie !
              </h2>
              <p className="mt-2 text-gray-600">
                Un e-mail de vérification a été envoyé à <strong className="text-gray-800">{email}</strong>.
              </p>
              <p className="mt-1 text-gray-500">
                Veuillez cliquer sur le lien dans l'e-mail pour activer votre compte.
                (Pensez à vérifier vos spams)
              </p>
              <Link
                to="/login"
                className="mt-6 inline-block text-sm font-semibold text-primary-600 hover:text-primary-700"
              >
                Retour à la page de connexion
              </Link>
            </div>

          ) : (
            
            // --- Formulaire d'inscription (existant) ---
            <>
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Icône */}
                <div className="flex justify-center">
                  <div className="bg-primary-100 rounded-full p-3">
                    <UserPlus className="h-8 w-8 text-primary-600" />
                  </div>
                </div>

                {/* Message d'erreur */}
                {error && (
                  <div className="bg-red-50 border border-red-200 rounded-lg p-4 flex items-start space-x-3">
                    <AlertCircle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
                    <p className="text-sm text-red-600">{error}</p>
                  </div>
                )}

                {/* Champ E-mail */}
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Adresse e-mail
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <Mail className="h-5 w-5 text-gray-400" />
                    </span>
                    <input
                      id="email"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      autoFocus
                      className="w-full px-4 py-3 pl-10 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="vous@exemple.com"
                    />
                  </div>
                </div>

                {/* Champ Mot de passe */}
                <div>
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                    Mot de passe
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <Lock className="h-5 w-5 text-gray-400" />
                    </span>
                    <input
                      id="password"
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className="w-full px-4 py-3 pl-10 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="••••••••"
                    />
                  </div>
                </div>
                
                {/* Champ Confirmation Mot de passe */}
                <div>
                  <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-2">
                    Confirmez le mot de passe
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <Lock className="h-5 w-5 text-gray-400" />
                    </span>
                    <input
                      id="confirmPassword"
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      className="w-full px-4 py-3 pl-10 rounded-lg border border-gray-300 focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                      placeholder="••••••••"
                    />
                  </div>
                </div>

                {/* Bouton de validation */}
                <button
                  type="submit"
                  disabled={loading || !email || !password || !confirmPassword}
                  className="w-full bg-gradient-to-r from-primary-600 to-success-600 text-white py-4 px-6 rounded-xl font-semibold text-lg hover:shadow-lg hover:scale-105 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
                >
                  {loading ? (
                    <span className="flex items-center justify-center">
                      <svg className="animate-spin h-5 w-5 mr-3" viewBox="0 0 24 24">
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                          fill="none"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      Création du compte...
                    </span>
                  ) : (
                    'Créer mon compte'
                  )}
                </button>
              </form>

              {/* Lien vers la connexion */}
              <div className="mt-6 text-center">
                <p className="text-sm text-gray-600">
                  Déjà un compte ?{' '}
                  <Link to="/login" className="font-semibold text-primary-600 hover:text-primary-700">
                    Connectez-vous
                  </Link>
                </p>
              </div>
            </>
          )}
          {/* --- FIN AFFICHAGE CONDITIONNEL --- */}

        </div>
      </div>
    </div>
  );
}

export default RegisterPage;